module.exports = __webpack_public_path__ + "static/about_sec4-6b2aa1193e5bb9e6c8f35ee3f5be77ca.png";